import { useBillingCompanyBillingInfoQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { BillingInfoType } from '../model/billingInfo';

const useBillingInfo = (companyId: string | undefined) => {
  const { data, refetch } = useBillingCompanyBillingInfoQuery({
    skip: !companyId,
    variables: { companyId: companyId ?? '' },
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  return {
    ...((data?.result || {}) as BillingInfoType),
    refetch,
  };
};

export default useBillingInfo;
